import styled, { css } from 'styled-components';

export const Cover = styled.div<{ isVisible: boolean }>`
  display: none;

  ${({ isVisible = false }) => {
    return (
      isVisible &&
      css`
        background: var(
          --ds-soldevelo-background-table-cover,
          var(--ds-fb-soldevelo-background-table-cover)
        );
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
      `
    );
  }}
`;
